import React from "react";

import { Box } from "@material-ui/core";
import { getBoxMarginProps, getBreakpointValue } from "./functions";
import { useTheme } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  slider: {
    '--divider-color': 'rgba(31, 196, 4, 0.25)',
    // '--default-handle-color': 'rgba(31, 196, 4, 0.25)',
    '--divider-width': '8px',
    color: 'rgba(31, 196, 4, 0.5)',
    maxWidth: props => props.maxWidth,
    width: props => props.width,
    height: props => props.height,
    '& img': {
      maxWidth: props => props.maxWidth,
      width: props => props.width,
      height: props => props.height,
    },
  }
});

export const ImageComparison = (props) => {
  const theme = useTheme();
  const breakpoint = useMediaQuery(theme.breakpoints.only('xs')) ? 'xs' : 'md';

  const boxProps = {
    style: {
        overflow: 'hidden',
        maxWidth: props[breakpoint].maxWidth ? `${getBreakpointValue(props, breakpoint, 'maxWidth')}px` : '100%',
        width: props[breakpoint].width ? `${getBreakpointValue(props, breakpoint, 'width')}px` : '100%',
        height: props[breakpoint].height ? `${getBreakpointValue(props, breakpoint, 'height')}px` : '100%',
    },
  };

  const classes = useStyles({
    maxWidth: boxProps.style.maxWidth,
    width: boxProps.style.width,
    height: boxProps.style.height,
  });
  
  const image1Src = getBreakpointValue(props, breakpoint, 'image1', 'url');
  const image2Src = getBreakpointValue(props, breakpoint, 'image2', 'url');
  const orientation = getBreakpointValue(props, breakpoint, 'orientation');

  return (
    <Box
      width="100%"
      {...boxProps}
      { ...getBoxMarginProps(props, breakpoint) }
    >
      <ImgComparisonSlider
        direction={orientation === 'landscape' ? 'horizontal' : 'vertical'}
        className={classes.slider}
      >
        <img slot="first" src={image1Src} />
        <img slot="second" src={image2Src} />
        <svg slot="handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6">
          <path d="M -3 -2 L -5 0 L -3 2 M -3 -2 L -3 2 M 3 -2 L 5 0 L 3 2 M 3 -2 L 3 2" fill="currentColor"></path>
        </svg>
      </ImgComparisonSlider>
    </Box>
  )
}
